import { Stack, Text, useTheme } from '@ltvco/refresh-lib/theme';
import { commaFormat } from '@ltvco/refresh-lib/utils';
import { AutoAwesomeOutlined } from '@mui/icons-material';

interface IAnalyzingStatusProps {
  searchLabel: string;
  searchValue: string;
  mileage?: string;
}

/**
 * AnalyzingStatus - Displays the analyzing state with vehicle search details
 * @component
 */
export const AnalyzingStatus = ({
  searchLabel,
  searchValue,
  mileage,
}: IAnalyzingStatusProps) => {
  const theme = useTheme();

  return (
    <Stack
      direction="row"
      gap={1}
      border={`1px solid ${theme.palette.divider}`}
      borderRadius={2}
      p={2}
      width={{ xs: '100%', md: 'fit-content' }}
    >
      <AutoAwesomeOutlined sx={{ color: theme.palette.primary.main }} />
      <Stack direction="column" alignItems="flex-start" gap={1}>
        <Text variant="body1">Analyzing....</Text>
        <Stack direction="row" gap={1} mt={0.5}>
          <Text
            variant="body1"
            bgcolor="primary.light"
            p={0.5}
            borderRadius={1}
            fontSize={{ xs: '0.825rem', md: '1rem' }}
          >
            {searchLabel}: {searchValue}
          </Text>
          {mileage && (
            <Text
              variant="body1"
              bgcolor="primary.light"
              p={0.5}
              borderRadius={1}
              fontSize={{ xs: '0.825rem', md: '1rem' }}
            >
              {commaFormat(mileage)}
            </Text>
          )}
        </Stack>
      </Stack>
    </Stack>
  );
};
